import { render, staticRenderFns } from "./BBAlert.vue?vue&type=template&id=5539af55&scoped=true"
import script from "./BBAlert.vue?vue&type=script&lang=js"
export * from "./BBAlert.vue?vue&type=script&lang=js"
import style0 from "./BBAlert.vue?vue&type=style&index=0&id=5539af55&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539af55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5539af55')) {
      api.createRecord('5539af55', component.options)
    } else {
      api.reload('5539af55', component.options)
    }
    module.hot.accept("./BBAlert.vue?vue&type=template&id=5539af55&scoped=true", function () {
      api.rerender('5539af55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/content/BBAlert.vue"
export default component.exports